import axios, { ENDPOINT } from '../utils/httpClient'

/**
 * Check if paylog is configured for the given organization
 * @param {string} shortname - The organization shortname
 * @returns {Promise<boolean>} - true if paylog is configured, false if using local remita
 */
export const checkPaylogConfiguration = async (shortname) => {
    try {
        const response = await axios.get(
            `${ENDPOINT}/paylog-customers/${shortname}/is-configured`
        )
        // Assuming the API returns { isConfigured: true/false } or similar
        // Adjust based on actual API response structure
        const isConfigured = response.data?.isConfigured ?? response.data ?? false
        // Store in localStorage as backup
        localStorage.setItem('paylog_configured', JSON.stringify(isConfigured))
        return isConfigured
    } catch (error) {
        console.error('Error checking paylog configuration:', error)
        // Default to false (local remita) if there's an error
        localStorage.setItem('paylog_configured', JSON.stringify(false))
        return false
    }
}

/**
 * Get paylog service fees for a school
 * @param {string} shortname - The school shortname
 * @returns {Promise<Object>} - Paylog customer data with serviceFees array
 */
export const getPaylogServiceFees = async (shortname) => {
    try {
        const response = await axios.get(
            `${ENDPOINT}/paylog-customers/by-school-shortname`,
            {
                params: {
                    shortname: shortname
                }
            }
        )
        return response.data
    } catch (error) {
        console.error('Error fetching paylog service fees:', error)
        throw error
    }
}

